












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { City } from '@/store/modules/location/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    cities: {
      type: Array as PropType<City[]>,
      required: true,
    },
    selectedCity: {
      type: String,
      default: '',
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.cities.map(({ city, state }, index) => ({
        key: index,
        content: { title: `${city}, ${state}`, icon: 'location' },
      }));

      return items;
    },
    selected(): number {
      return this.cities.findIndex(({ city, state }) => `${city}, ${state}` === this.selectedCity);
    },
  },
  methods: {
    selectedHandler(selectedCard: CardInfo) {
      const selected = this.cities.find(
        ({ city, state }) => `${city}, ${state}` === selectedCard.content.title,
      );
      setTimeout(() => {
        this.$emit('selected', selected);
      }, 300);
    },
  },
});
